export default __webpack_public_path__ + "static/media/H4001.d779fcab.mp3";